import { api } from '@/shared/api';
import { extractEsiaCode } from './extractEsiaCode';
import {
  isAuthPayloadConsumed,
  markAuthPayloadConsumed,
} from './consumedAuthPayload';
import type { AppDispatch } from '@/app/store';
import type { AuthResult } from '@/shared/types';

export async function initAuth(
  startParam: string | undefined,
  dispatch: AppDispatch
): Promise<AuthResult | null> {
  const esiaCode = extractEsiaCode(startParam);
  if (!esiaCode) return null;

  if (isAuthPayloadConsumed(esiaCode)) return null;

  let result;
  try {
    result = await dispatch(
      api.endpoints.exchangeEsiaCode.initiate({ code: esiaCode })
    ).unwrap();
  } catch (err) {
    const status = (err as { status?: number | string } | undefined)?.status;
    if (typeof status === 'number' && status >= 400 && status < 500) {
      markAuthPayloadConsumed(esiaCode);
    }
    throw err;
  }

  markAuthPayloadConsumed(esiaCode);

  return {
    accessToken: result.access_token,
    refreshToken: result.refresh_token,
    perUserId: result.per_user_id,
  };
}
